<div class="col-lg-12 modeso-title">
  <h1>{{titleText}}</h1>
</div>
